export const base_url = 'https://yslamo.com';